import type { NotificationBanner } from "@/modules/notificationBanner/api/getNotificationBanner"

import { getHiddenBannerCookieValue } from "@/modules/notificationBanner/utils/getHiddenBannerCookieValue"

type IsNotificationBannerVisibleParams = {
  cookieBannerValue?: string
  notificationBanner?: NotificationBanner | void
}

export const isNotificationBannerVisible = ({
  cookieBannerValue,
  notificationBanner,
}: IsNotificationBannerVisibleParams): boolean => {
  if (!notificationBanner) return false
  // API returns a default empty notificationBanner object if there is no banner to display.
  if (!notificationBanner.text) return false

  const dismissBannerId = getHiddenBannerCookieValue(notificationBanner)
  const isBannerVisible = cookieBannerValue !== dismissBannerId

  return isBannerVisible
}
